import ValidationInterface from '@/plans/common/validation-interface';
import { EVENT_SERVICES_KEYS } from '@/plans/EVENT_SERVICES/constants';
import { webinarCategories } from '@/common/persist-cart/categories';

export default class extends ValidationInterface {
  async requires() {
    return [this.current(EVENT_SERVICES_KEYS).require(webinarCategories)];
  }

  async conflicts() {
    return EVENT_SERVICES_KEYS;
  }
}
